import { Component, OnInit, ElementRef, Output, EventEmitter } from '@angular/core';
import { AccessibilityService } from 'src/app/services/accessibility.service';

@Component({
  selector: 'app-popup-menu',
  templateUrl: './popup-menu.component.html',
  styleUrls: ['./popup-menu.component.css']
})
export class PopupMenuComponent implements OnInit {

  public visualAccessibilityModeOn = false;

  private element: any;
  // language: number;
  // uiTexts: {[key: string]: string[]};
  shouldHandleClock = false;

  @Output() openCallback = new EventEmitter();
  @Output() closeCallback = new EventEmitter();

  constructor(
    private accessibilityService: AccessibilityService,
    private elem: ElementRef
  ) {
    this.element = elem.nativeElement;
  }

  public openPopupMenu(): void {
    this.element.style.display = 'block';
    document.body.classList.add('popupmenu-open');
  }


  public closePopupMenu(): void {
    this.element.style.display = 'none';
    document.body.classList.remove('popupmenu-open');
  }

  ngOnInit(): void {

    // NOTE: Below lines are removed, as they mean that popup menus aren't destroyed when scenes are changed by router. This could lead to
    //       multiple useless popups. The same effect can be achieved by always putting the popup at the end of the HTML.
    // TODO: If time create a more elegant solution. Maybe Z-axis?

    // move element to bottom of page (just before </body>) so it can be displayed above everything else
    // document.body.appendChild(this.element);

    this.closePopupMenu();
    this.visualAccessibilityModeOn = this.accessibilityService.highContrastAccessibilityOn;
  }

  public tryRestartClock(): void {
    if (this.shouldHandleClock) {
    }
  }


}
